// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ng69","label":"styles_label__71k7K"};